export const LINK_CATEGORIES = {
    code: [
        { name: 'github', display: 'Github' },
        { name: 'gitlab', display: 'Gitlab' }
    ],
    data: [
        { name: 'geo', display: 'Gene Expression Omnibus' },
        { name: 'dbGap', display: 'The Database of Genotypes and Phenotypes' },
        { name: 'kaggle', display: 'Kaggle' },
        { name: 'dryad', display: 'Dryad' },
        { name: 'empiar', display: 'Electron Microscopy Public Image Archive' },
        { name: 'gigaDb', display: 'GIGADB' },
        { name: 'zenodo', display: 'Zenodo' },
        { name: 'ega', display: 'European Genome-phenome Archive' },
        { name: 'xlsx', display: 'Excel Sheets' },
        { name: 'csv', display: 'Comma-separated Value Files' },
        { name: 'proteinDataBank', display: 'Protein Data Bank' },
        { name: 'dataverse', display: 'Dataverse' },
        { name: 'openScienceFramework', display: 'Open Science Framework' },
        { name: 'finngenGitbook', display: 'FinnGen' },
        { name: 'gtexPortal', display: 'Genotype-Tissue Expression' },
        { name: 'ebiAcUk', display: 'EMBL-EBI' },
        { name: 'mendeley', display: 'Mendeley' },
        { name: 'R', display: 'RDS File' }
    ],
    containers: [
        { name: 'codeOcean', display: 'Code Ocean Capsules' },
        { name: 'colab', display: 'Google Colab Capsules' }
    ],
    results: [
        { name: 'gsea', display: 'Gene Set Enrichment Analysis' },
        { name: 'figshare', display: 'Figshare' }
    ],
    trials: [
        { name: 'clinicalTrial', display: 'ClinicalTrials.gov' },
        { name: 'euCTR', display: 'EU Clinical Trials Register' },
        { name: 'vivli', display: 'Vivli' },
        { name: 'yoda', display: 'The YODA Project' }
    ],
    celllines: [{ name: 'cellosaurus', display: 'Cellosaurus' }],
    plasmids: [
        { name: 'addgene', display: 'Addgene' },
        { name: 'dnasu', display: 'DNASU Plasmid Repository' },
        { name: 'deepomics', display: 'Deepomics' }
    ],
    protocols: [
        { name: 'protocolsIO', display: 'Protocols.io' },
        { name: 'bioProtocol', display: 'Bio-protocol' },
        { name: 'benchling', display: 'Benchling' },
        { name: 'labArchives', display: 'LabArchives' }
    ],
    packages: [
        { name: 'bioconductor', display: 'Bioconductor' },
        { name: 'pypi', display: 'Pypi' },
        { name: 'CRAN', display: 'CRAN' }
    ],
    miscellaneous: [
        { name: 'IEEE', display: 'Institute of Electrical and Electronics Engineers' },
        { name: 'pdf', display: 'PDFs' },
        { name: 'docx', display: 'Word Documents' },
        { name: 'zip', display: 'Compressed Files' }
    ],
    other: [{ name: 'otherLinks', display: 'Any other link' }]
};
